/**
 * Session-level events raised by the API client (outside React) and handled by the app shell
 * (inside React, where navigation is possible).
 */
export type AuthEvent =
  | 'session-expired'
  | 'tenant-suspended'
  | 'user-disabled'
  // Step 15: the time to view as someone (Tekansa support) has ended.
  | 'act-as-ended';

type Listener = (event: AuthEvent) => void;
const listeners = new Set<Listener>();

export function onAuthEvent(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitAuthEvent(event: AuthEvent): void {
  for (const listener of listeners) listener(event);
}

/**
 * True once we know the person was logged in during this visit. A 401 then means the
 * session EXPIRED (show a message); before that, it just means "not logged in yet".
 */
let sessionKnown = false;
export const markSessionKnown = (known: boolean): void => {
  sessionKnown = known;
};
export const isSessionKnown = (): boolean => sessionKnown;
